import { computed, inject } from '@angular/core';
import { routeParamAsNumber } from '@softline/application';
import { RepositoryObjectService, Result } from '@softline/core';
import { TimeReport } from '../models/time-report.model';
import { TimeReportRepository } from '../repository/time-report.repository';
import { TimeReportsService } from './time-reports.service';

export class TimeReportService extends RepositoryObjectService<
  TimeReport,
  Result<TimeReport>,
  { id: number },
  { id: number }
> {
  timeReportsService = inject(TimeReportsService);
  constructor() {
    super(inject(TimeReportRepository));
  }

  timeReportId = routeParamAsNumber('id');

  override params = computed(() => {
    return { id: this.timeReportId() ?? 0 };
  });

  protected override getValue(result: Result<TimeReport>): TimeReport {
    if (
      result?.result.zbewegungsarten &&
      Array.isArray(result?.result.zbewegungsarten) &&
      result.result.zbewegungsarten?.length > 0
    ) {
      result.result.zbewegungsarten = result?.result.zbewegungsarten[0];
    }
    return result?.result;
  }

  override async update(
    value: Partial<TimeReport>,
    params: { id: number }
  ): Promise<TimeReport> {
    if (!value) {
      throw new Error('Value is required for update');
    }
    const updatedValue = {
      ...this.value(),
      ...value,
      from: value?.from?.replace('T', '').substring(0, 8),
      to: value?.to?.replace('T', '').substring(0, 8),
      from2: value.from2?.replace('T', '').substring(0, 8) ?? undefined,
      to2: value.to2?.replace('T', '').substring(0, 8) ?? undefined,
      zbewegungsarten: value?.zbewegungsarten ? [value.zbewegungsarten] : undefined,
      id: String(this.value()?.id ?? 0),
    };
    try {
      const result = await this.repository.update(
        updatedValue as unknown as TimeReport,
        params
      );
      this.timeReportsService.reload();
      return result.result;
    } catch (error) {
      throw new Error(`${error}`);
    }
  }
}
